import { Image } from "@fluentui/react";
import { IWithConfigurationProps, WithConfiguration } from "Components/Generic/Configuration";
import { Logos } from "Images";
import { useSelector } from "react-redux";
import { selectActualTheme } from "Store/Selectors/UI";
import { usePoweredByStyles } from "./UsePoweredByStyles";

export const PoweredBy = WithConfiguration((props: IWithConfigurationProps): JSX.Element => {
  const { config } = props;
  const styles = usePoweredByStyles();
  const themeType = useSelector(selectActualTheme);

  const showPoweredBy = config.hasCustomLogo();

  return (
    <div className={styles.root}>
      {showPoweredBy && (
        <Image
          alt="Powered By ORBIS SE"
          className={styles.logo}
          src={Logos(`ORBIS_${themeType}`)}
          title="Powered By ORBIS SE"
        />
      )}
    </div>
  );
});
